import {getCycleStart} from './getCycleStart'
import {addLog} from './addLog'
import {logs} from '../Logs.js'

/* eslint-disable quotes, max-len */
export const runSteps = () => (dispatch) => {
  const cycleStart = getCycleStart()
  const currentOffset = Date.now() - cycleStart
  let lastReqTime = 10
  for (let lIndex = 0; lIndex < logs.length; lIndex++) {
    const log = logs[lIndex]
    const hasHappened = (!log?.time || (currentOffset > log?.time))
    const timeoutTime = hasHappened ? 1 : log?.time - currentOffset
    if (hasHappened) { // run right away so everything is synchronous
      dispatch(addLog(log, cycleStart))
    } else {
      // Need offset so no two timeouts run too close to each other
      let offset = 0
      if ((log?.time - lastReqTime) < 20) {
        offset = 20
      }
      lastReqTime = log?.time + offset
      setTimeout(() => {
        dispatch(addLog(log, cycleStart))
      }, timeoutTime + offset)
    }
  }
}

